module.exports = __webpack_public_path__ + "img/blue.496c08cf.gif";